import axios from 'axios';
import { toast } from 'react-toastify';
// KOMALADEWI ENDPOINT
// const baseURL = process.env.REACT_APP_BASE_URL_KOMALADEWI;
// export const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL_KOMALADEWI;
// KOMALADEWI ENDPOINT

// NURULAROFAH ENDPOINT
const baseURL = process.env.REACT_APP_BASE_URL;
export const imageBaseUrl = process.env.REACT_APP_IMAGE_BASE_URL;
// NURULAROFAH ENDPOINT

export const getToken = () =>
  localStorage.getItem('token') ? localStorage.getItem('token') : null;
export const getAuthorizationHeader = () => `Bearer ${getToken()}`;
export const http = axios.create({
  baseURL,
  timeout: 25000,
});

http.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.code === 'ECONNABORTED' || error.message === 'Network Error') {
      toast.error('Koneksi tidak stabil, silahkan coba lagi', {
        toastId: 'connection-error',
      });
    }
    return Promise.reject(error);
  },
);
